import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { FiBell } from 'react-icons/fi';
import { createSearchList } from '../../store/actions/searchActions';
import lang from './lang';
import './SearchBar.css';
import defaultImg from '../../assets/img/default/store.svg';

class SearchBar extends Component {
    state = {
        query: '', data: [],
        isVisible: false,
        searchSuggestion: 'none',
    }

    searchHandler = (e) => {
        const { value } = e.target;
        let data = [];

        data = this.props.products.filter(item => {
            const itemName = item.name.toLowerCase().includes(value.toLowerCase());
            const itemCode = item.code.toLowerCase().includes(value.toLowerCase());

            if (itemName || itemCode) {
                return item
            }
        });

        this.setState({ query: value, data, searchSuggestion: 'block' });
    }

    onSearchButtonClick = () => {
        this.props.createSearchList(this.state.data);
        this.setState({
            query: '',
            data: [],
            isVisible: false,
            searchSuggestion: false
        });
        this.props.history.push('/search-result');
    }

    render() {
        const { search } = lang[this.props.user.lang || 'uz']

        return (
            <div id="top-bar" onMouseLeave={() => this.setState({ searchSuggestion: 'none' })}>
                <div className="container">
                    <div className="row">
                        <div className="search-input">
                            <input
                                type="search"
                                className="form-control mr-2"
                                value={this.state.query}
                                onChange={(e) => this.searchHandler(e)}
                            />
                            <ul
                                className={`list-group list-group-flush ${this.state.data.length !== 0 ? 'searchSuggestions' : ''}`}
                                style={{ display: this.state.searchSuggestion }}
                            >
                                {
                                    this.state.data.slice(0, 5).map(item => {
                                        return (
                                            <li className="list-group-item list-group-item-action" key={item.id}>
                                                <Link
                                                    to={`/products/${item.id}`}
                                                    onClick={() => {
                                                        this.setState({
                                                            query: '',
                                                            data: [],
                                                            isVisible: false,
                                                            searchSuggestion: false
                                                        })
                                                    }}
                                                    className="d-block text-capitalize"
                                                >
                                                    <table className="w-100">
                                                        <tbody>
                                                            <tr className="d-flex">
                                                                <td className="w-50">
                                                                    <span>{item.name.toLowerCase().includes(this.state.query.toLowerCase()) ? item.name : item.code}</span>
                                                                </td>
                                                                <td className="w-25 text-right">
                                                                    <span className="ml-auto d-inline-block"><span className="text-success">{item.dimensions}</span></span>
                                                                </td>
                                                                <td className="w-25 text-right">
                                                                    <span className="text-dark">{item.quality}</span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>


                                                </Link>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                        <div className="buttons">
                            <button className="btn btn-success btn-sm mr-2" onClick={this.onSearchButtonClick}>{search}</button>
                            {
                                this.props.auth.isAdmin ?
                                    (
                                        <Fragment>
                                            <Link to="/notifications" className="ml-auto notification-bell">
                                                <FiBell className="icon text-success" />
                                                {this.props.notifications.filter(item => item.active === true).length > 0 ? <span className="badge badge-pill badge-success">{this.props.notifications.filter(item => item.active === true).length}</span> : ''}
                                            </Link>
                                            <Link
                                                to="/profile"
                                                className="nav-item"
                                                onClick={this.sideBarLinkHandler}
                                            >
                                                <img
                                                    src={this.props.user.img || defaultImg}
                                                    onError={(e) => e.target.src = defaultImg}
                                                    alt={this.props.user.name}
                                                    className="img-fluid"
                                                    id="user-icon"
                                                />
                                            </Link>
                                        </Fragment>
                                    ) : null
                            }

                        </div>

                    </div>
                </div>
            </div >

        );
    }
}

const mapStateToProps = state => {
    return {
        products: state.products.products,
        search: state.search.search,
        notifications: state.notifications.notifications,
        auth: state.auth,
        user: state.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        createSearchList: (search) => dispatch(createSearchList(search))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SearchBar));
